import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Subsection from "components/Subsection";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";
import { getCostShareSubtotal, getFAAmountSubtotal, getPeriodSubtotal, getRateSubtotal } from "utils/budgetBuilder";

import styles from "./styles.css";


const SummaryList = () => {
	const { currencyFormatter } = useTenantFormatter();
	const internalCategories = useSelector(budgetBuilderSelectors.internalCostShare);
	const externalCategories = useSelector(budgetBuilderSelectors.externalCostShare);
	const hasFringeRate = useSelector(budgetBuilderSelectors.hasFringeRate(true));
	const hasSalaryRate = useSelector(budgetBuilderSelectors.hasSalaryRate(true));
	const faRateAmount = useSelector(budgetBuilderSelectors.currentPeriodRate);
	const members = useSelector(budgetBuilderSelectors.researchTeamMembers);
	const currentPeriodRate = useSelector(budgetBuilderSelectors.currentPeriodRate);

	const researchTeamSubtotal = useMemo(
		() => getPeriodSubtotal(members, true),
		[ members ],
	);
	const rateSubtotal = useMemo(
		() => getRateSubtotal(currentPeriodRate, members, hasFringeRate, hasSalaryRate, true),
		[ currentPeriodRate, members, hasFringeRate, hasSalaryRate ],
	);
	const internalCostShareSubtotal = useMemo(
		() => getCostShareSubtotal(internalCategories) + researchTeamSubtotal,
		[ internalCategories, researchTeamSubtotal ],
	);
	const externalCostShareSubtotal = useMemo(
		() => getCostShareSubtotal(externalCategories),
		[ externalCategories ],
	);
	const internalFASubtotal = useMemo(
		() => getFAAmountSubtotal(internalCategories, faRateAmount),
		[ internalCategories, faRateAmount ],
	);
	const total = useMemo(
		() => internalCostShareSubtotal + externalCostShareSubtotal,
		[ externalCostShareSubtotal, internalCostShareSubtotal ],
	);

	return (
		<Subsection title={"Cost Share Total"}>
			<Table captionText="Cost Share Summary">
				<Table.Body>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Research Team Salary and Fringe Subtotal"}</span>
						</Table.Cell>

						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(researchTeamSubtotal)}</span>
						</Table.Cell>
					</Table.Row>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Research Team F&A Subtotal"}</span>
						</Table.Cell>

						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(rateSubtotal)}</span>
						</Table.Cell>
					</Table.Row>

					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Research Team Subtotal"}</span>
						</Table.Cell>

						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(researchTeamSubtotal)}</span>
						</Table.Cell>
					</Table.Row>

					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Internal F&A Subtotal"}</span>
						</Table.Cell>

						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(internalFASubtotal)}</span>
						</Table.Cell>
					</Table.Row>

					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Internal Subtotal"}</span>
						</Table.Cell>

						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(internalCostShareSubtotal)}</span>
						</Table.Cell>
					</Table.Row>

					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"External Subtotal"}</span>
						</Table.Cell>

						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(externalCostShareSubtotal)}</span>
						</Table.Cell>
					</Table.Row>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell className={styles.rowHeaderCell} width="nine">
							<span className={styles.bold}>{"Cost Share Total"}</span>
						</Table.Cell>
						<Table.Cell
							className={`${styles.rowHeaderCell} ${styles.cellAlignRight} ${styles.valueCellPadding}`}
							width="two"
						>
							<span>{currencyFormatter(total)}</span>
						</Table.Cell>
					</Table.Row>
				</Table.Body>
			</Table>
		</Subsection>

	);
};

export default SummaryList;
